//@flow
import React from 'react';
import i18n from 'app/common/lib/i18n';
import List from 'app/common/react/ui/experimental/list/List';
import ListItem from 'app/common/react/ui/experimental/list/ListItem';
import { Box, Flyout, IconButton } from 'gestalt';

type Props = {|
  onCreateBoard: () => void,
  onCreatePin: () => void,
|};

type State = {|
  flyoutOpen: boolean,
|};

export default class ProfileActionsButton extends React.Component<Props, State> {
  state = {
    flyoutOpen: false,
  };

  anchor: ?HTMLElement;

  toggleFlyout = () => {
    this.setState((prevState) => ({
      flyoutOpen: !prevState.flyoutOpen,
    }));
  };

  toggleFlyoutAndCompleteFunction = (func: () => void) => {
    this.toggleFlyout();
    func();
  };

  render() {
    const { onCreateBoard, onCreatePin } = this.props;

    // RJ TODO: use this string below
    i18n._('Profile actions', 'Button that renders additional actions to do on the profile');

    return (
      <React.Fragment>
        <div
          ref={(c) => {
            this.anchor = c;
          }}
        >
          <IconButton
            accessibilityLabel={i18n._(
              'Profile actions overflow',
              'Button that renders additional actions to do on the profile',
            )}
            icon="add"
            onClick={this.toggleFlyout}
            size="lg"
          />
        </div>
        {this.state.flyoutOpen && (
          <Flyout anchor={this.anchor} idealDirection="down" onDismiss={this.toggleFlyout}>
            <Box width="100%">
              <List>
                <ListItem
                  onClick={() => this.toggleFlyoutAndCompleteFunction(onCreateBoard)}
                  text={i18n._('Create board', 'Invite collaborators button')}
                />
                <ListItem
                  onClick={() => this.toggleFlyoutAndCompleteFunction(onCreatePin)}
                  text={i18n._('Create Pin', 'Text for sharing a board')}
                />
              </List>
            </Box>
          </Flyout>
        )}
      </React.Fragment>
    );
  }
}
